import { useFeatureFlagEnabled } from "posthog-js/react";

export enum FeatureFlag {
  INTEGRATIONS_SLACK_ENABLED = "integrations-slack-enabled",
  PROJECT_GRAPH_PROPERTY_ENRICHMENT_ENABLED = "project-graph-property-enrichment-enabled",
  PROJECT_GRAPH_EDIT_WIDGET_ENABLED = "project-graph-edit-widget-enabled",
  PROJECT_MAPPING_METHOD_JSON_ENABLED = "project-mapping-method-json-enabled",
  PROJECT_MAPPING_METHOD_BLANK_ENABLED = "project-mapping-method-blank-enabled",
  PROJECT_SETTINGS_CONFIGURATION_ENABLED = "project-settings-configuration-enabled",
  SOURCE_TYPE_FILE_UPLOAD_ENABLED = "source-type-file-upload-enabled",
  SOURCE_TYPE_TEXT_ENABLED = "source-type-text-enabled",
  SOURCE_TYPE_WEBHOOK_ENABLED = "source-type-webhook-enabled",
  SOURCE_TYPE_SLACK_ENABLED = "source-type-slack-enabled",
  SOURCE_TYPE_JIRA_ENABLED = "source-type-jira-enabled",
  SOURCE_TYPE_LINEAR_ENABLED = "source-type-linear-enabled",
  SOURCE_TYPE_NETSUITE_ENABLED = "source-type-netsuite-enabled",
  SOURCE_TYPE_BROWSERBASE_ENABLED = "source-type-browserbase-enabled",
  SOURCE_TYPE_CLICKHOUSE_ENABLED = "source-type-clickhouse-enabled",
  SOURCE_TYPE_MYSQL_ENABLED = "source-type-mysql-enabled",
  SOURCE_TYPE_SNOWFLAKE_ENABLED = "source-type-snowflake-enabled",
  SOURCE_TYPE_GOOGLE_DRIVE_ENABLED = "source-type-google-drive-enabled",
  SOURCE_TYPE_S3_ENABLED = "source-type-s3-enabled",
  SOURCE_TYPE_SALESFORCE_ENABLED = "source-type-salesforce-enabled",
  SOURCE_TYPE_ATTIO_ENABLED = "source-type-attio-enabled",
  SOURCE_TYPE_NOTION_ENABLED = "source-type-notion-enabled",
  SOURCE_TYPE_POSTGRES_ENABLED = "source-type-postgres-enabled",
  SOURCE_TYPE_BIGQUERY_ENABLED = "source-type-bigquery-enabled",
  SOURCE_TYPE_HUBSPOT_ENABLED = "source-type-hubspot-enabled",
  SOURCE_TYPE_GITHUB_ENABLED = "source-type-github-enabled",
  SOURCE_TYPE_CONFLUENCE_ENABLED = "source-type-confluence-enabled",
  SOURCE_TYPE_WIKIPEDIA_ENABLED = "source-type-wikipedia-enabled",
  SOURCE_DETAIL_ACTIVITY_FEED_ENABLED = "source-detail-activity-feed-enabled",
  WORKSPACE_SETTINGS_API_ENABLED = "workspace-settings-api-enabled",
}

export const useFeatureFlag = (featureFlag: FeatureFlag | undefined): boolean => {
  const isEnabled = useFeatureFlagEnabled(featureFlag ?? "");
  if (featureFlag === undefined || isEnabled === undefined) {
    return false;
  }
  return isEnabled;
};
